import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-pdf-back-page',
    templateUrl: './back-page-for-pdf.component.html',
    standalone: false
})
export class BackPageForPdfComponent extends BlockAbstractComponent implements OnInit {
    address!: [];

    override ngOnInit() {
        super.ngOnInit();
        this.formatAddress(this.user!.data.POSTAL_ADDRESS);
    }

    formatAddress(data: any) {
        // convert string to array and remove commas
        return this.address = data.split(',').map((item: any) => item.trim());
    }

}
